import { FC } from 'react';
import Button, { ButtonProps } from '../Button/Button';
import styles from './ShodawButton.module.scss';

const ShodawButton: FC<ButtonProps & { shadow?: boolean; bg?: string }> = (props) => {
    return (
        <div className={styles.ShodawButton}>
            {!props.shadow && (
                <div
                    style={{ background: props.bg ? props.bg : 'linear-gradient(180deg, rgba(12, 13, 15, 0) 0%, #0c0d0f 35.45%)' }}
                    className={styles.bg}></div>
            )}
            <Button {...props} />
        </div>
    );
};

export default ShodawButton;
